import { useState } from "react";

const faqs = [
  {
    q: "桃桃漫画网是什么？",
    a: "桃桃漫画网是一个专注桃色剧情、暧昧桥段、脸红情节与恋爱拉扯类漫画的在线阅读平台，精选情感发展细腻、心动瞬间密集的恋爱作品，方便喜欢慢热感情的读者按栏目快速找到对味的漫画。",
  },
  {
    q: "在桃桃漫画网上看漫画需要付费吗？",
    a: "目前桃桃漫画网上的作品均提供免费在线试读，热门连载会持续更新最新章节，部分完结佳作也可以完整畅读，方便你先试读再决定是否追更。",
  },
  {
    q: "桃桃漫画网上的作品更新频率如何？",
    a: "热门连载作品通常会按更新周期持续上架新章节，最新更新板块会实时展示刚刚上架的章节。你可以关注作品详情页查看最新章节，也可以订阅恋爱更新提醒，第一时间收到推送。",
  },
  {
    q: "如何找到符合我口味的恋爱漫画？",
    a: "我们按照剧情类型划分了纯爱甜宠、暗恋心事、冤家拉扯、契约恋爱、职场暧昧、校园心动六大栏目，并配有心动指数、热门榜单和编辑精选，方便你根据喜欢的情感风格快速筛选作品。",
  },
  {
    q: "我想追更一部作品，怎样及时知道更新？",
    a: "你可以在页面底部订阅恋爱更新提醒，填入常用邮箱后，热门作品的更新、编辑精选和心动番外会第一时间推送到你的邮箱，不错过任何脸红瞬间。",
  },
  {
    q: "桃桃漫画网的内容适合哪些读者？",
    a: "桃桃漫画网主打感情线细腻、升温缓慢的恋爱剧情，适合喜欢纯爱甜宠、暗恋心事、冤家拉扯、契约恋爱等浪漫题材的成年读者阅读。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section className="bg-background-100/70 py-14 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="mx-auto w-full max-w-[1000px] px-4">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">想知道的都在这里</h2>
          <p className="mx-auto mt-2 max-w-xl text-[15px] text-foreground-600">
            关于桃桃漫画网的使用方式与内容定位，几个常见问题帮你快速上手。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-200" : "border-background-200/70"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className={`text-[15px] font-medium ${isOpen ? "text-primary-600" : "text-foreground-950"}`}>
                    {item.q}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                      isOpen ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-[15px] leading-relaxed text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}